import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DIET_CATEGORY_QUERY } from '../graphql/queries'
import { FETCH_DIET_CATEGORY } from '../redux/action-types'
import { cleanupFetchDietCategory } from '../redux/actions'

const useDietCategoryQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchDietCategory)

  const { isLoading, error, data } = useSelector(
    store => store.diets.dietCategory,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        DIET_CATEGORY_QUERY,
        { id },
        dispatch,
        FETCH_DIET_CATEGORY,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default useDietCategoryQuery
